import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BaseHttpClientService } from '../../../commons/services/base-http-client.service';
import { BaseHandleErrorService } from '../../../commons/services/base-handle-error.service';
import { environment } from '../../../../environments/environment';
import { PasswordRecoveryConstans } from '../../../commons/constants/password-recovery-constants';


@Injectable({
  providedIn: 'root'
})
export class PasswordRecoveryService {
  constructor(
    private _httpClientService: BaseHttpClientService,
    private _handleErrorHelper: BaseHandleErrorService,
    private _httpClient: HttpClient,
  ) {
  }

  public sendPasswordRecoveryEmail(passModel: any,country:any): Observable<boolean> {
    return this._httpClientService.sendPostRequestCredentials(PasswordRecoveryConstans.PasswordRecoveryEmailPath, passModel, false, environment.restApi.msB2C, false, country).pipe(
      map( response => {
        return response;
      }), catchError((error: HttpErrorResponse) => this._handleErrorHelper.handleError(error))
    )
  }
  public PasswordRecovery(passModel: any,country:any,token:any): Observable<boolean> {
    return this._httpClientService.sendPostRequestCredentialsCustomToken(PasswordRecoveryConstans.PasswordRecoveryPath, passModel,true, environment.restApi.msB2C, false, country,token).pipe(
      map( response => {
        return response;
      }), catchError((error: HttpErrorResponse) => this._handleErrorHelper.handleError(error))
    )
  }
}
